import classNames from "classnames";
import { imagePlaceholder, slugify } from "helpers/utils";
import { AttributeOption } from "interfaces/products";
import { ListBox, ListBoxItem } from "react-aria-components";
import { CloudinaryImage } from "react-tiny-cloudinary";

import type { AttributePanelContentProps } from ".";

import styles from "./attribute-panel.module.scss";

export const AttributePanelList = ({
    options,
    compact,
    ...props
}: AttributePanelContentProps) => {
    return (
        <ListBox {...props} className={styles.attributePanelList}>
            {[...options].map((item) => (
                <AttributePanelListOption
                    key={item.id}
                    option={item}
                    compact={compact}
                />
            ))}
        </ListBox>
    );
};

function AttributePanelListOption({
    option,
    compact,
}: {
    option: AttributeOption;
    compact?: boolean;
}) {
    return (
        <ListBoxItem
            id={option.id}
            textValue={option.option}
            className={classNames({
                [styles.attributePanelListItem]: true,
                [`al-pdp-vc__panel-item al-pdp-vc__panel-item--${slugify(
                    option.option,
                )}`]: true,
                [styles.compact]: compact,
            })}
        >
            <CloudinaryImage
                type={option.primary_image ? "fetch" : "upload"}
                cldId={option.primary_image?.image ?? imagePlaceholder}
                cldSrcSet={[80, 160, 240, 320]}
                crop="pad"
                aspectRatio="1:1"
            >
                <img alt="" sizes="80px" />
            </CloudinaryImage>
            <div>
                <span className={styles.name}>{option.option}</span>
            </div>
        </ListBoxItem>
    );
}
